import { ITextTransform } from '../types';

export const textTransform: ITextTransform = {
  heading: 'none',
  button: 'none',
  overline: 'uppercase',
  body: 'none',
};
